<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<!-- <el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.businessID" filterable placeholder="请选择商家">
				    <el-option v-for="item in businessList" :key="item.entry_business_id" :label="item.entry_business_name" :value="item.entry_business_id"> </el-option>
				</el-select>
			</el-col> -->
			<!-- <el-col :span="5">
				<el-select clearable style="width: 100%;" v-model="searchInfo.sendername" filterable placeholder="请选择档口">
				    <el-option v-for="item in stallList" :key="item.sendername" :label="item.stall_name" :value="item.sendername"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="4">
				<el-select clearable style="width: 100%;" v-model="searchInfo.sendertel" filterable placeholder="请选择菜品分类">
				    <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col> -->
			<el-col :span="7">
				<el-input clearable placeholder="请输入姓名" v-model="searchInfo.sendername">
					<template slot="prepend">配送员姓名</template>
				</el-input>
			</el-col>	
			<el-col :span="7">
				<el-input clearable placeholder="请输入电话" v-model="searchInfo.sendertel">
					<template slot="prepend">配送员电话</template>
				</el-input>
			</el-col>
			<el-col :span="5">
				<el-select clearable style="width: 100%;" v-model="searchInfo.timevalue" filterable placeholder="请选择时间">
				    <el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;" :gutter="20">
			<el-col :span="4">
				<el-date-picker style="width: 100%;" v-model="searchInfo.begintime" type="date" placeholder="选择开始日期"></el-date-picker>
			</el-col>
			<el-col :span="4"> 
				<el-date-picker style="width: 100%;" v-model="searchInfo.endtime" type="date" placeholder="选择结束日期"></el-date-picker>
			</el-col>	
			<el-col :span="8"> 
				<el-button type="primary" @click="searchData" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-tickets" @click="exportOrders">导出明细</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-row>
				<el-col :span="12">
					<span style="color: #000;font-size: 15px;">
						日期：{{ this.statinfo.begintime }} 至 {{ this.statinfo.endtime }}
					</span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						配送订单总计：{{ this.statinfo.order_count }}单
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						收入合计：{{ this.statinfo.total_income }}元
					</span>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 10px;">
			<el-table :data="recordList"  style="width: 100%"  height="700">
				<el-table-column fixed="left" prop="deliverpersonname" label="配送员姓名" width="120" align="center"></el-table-column>
			    <el-table-column prop="deliverpersontelphone" label="配送员电话" width="120" align="center"></el-table-column>
				<el-table-column prop="orderno" label="订单编号" width="180" align="center"></el-table-column>
				<el-table-column prop="ordertime" label="下单时间" width="120" align="center"></el-table-column>
				<el-table-column prop="deleverytime" label="配送完成时间" width="120" align="center"></el-table-column>
				<el-table-column prop="deliverfee" label="配送费" width="100" align="center"></el-table-column>
				<el-table-column prop="orderamount" label="订单金额" width="100" align="center"></el-table-column>
				<el-table-column prop="packprice" label="打包费" width="100" align="center"></el-table-column>				
				<el-table-column prop="statename" label="状态" align="center"></el-table-column>	
				<el-table-column fixed="right" prop="op" label="操作" width="120" align="center">
					<template slot-scope="scope">
						<a @click="copyOrderNo(scope.$index, scope.row)" title="复制单号" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-dish">复制单号</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="orderTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import {nfsprefix, baseUrl } from '/static/baseUrl.js'
	import {queryDeliveryDetailList,queryDeliverySaleStat,exportDeliveryOrderDetail } from '/static/apiUrl.js'
	export default {
		name : 'DeliveryDetail',
		data() {
			return {
				detailShow: false,
				editok : false,
				detailTitle: '订单详情',
				selectorderno: '',	
				searchInfo:{
					sendername: '',
					sendertel: '',
					begintime: '',
					endtime: '',
					timevalue: '1',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				timeList: [
					{
						label : '全部日期',
						value : '0',
					},
					{
						label : '今天',
						value : '1',
					},
					{
						label : '昨天',
						value : '2',
					},
					{
						label : '本周',
						value : '3',
					},
					{
						label : '本月',
						value : '4',
					},
					{
						label : '本季度',
						value : '5',
					},
					{
						label : '本年',
						value : '6',
					},
				],
				orderTotal : 0,
				recordList: [],	
				statinfo: {		
					begintime: '',
					endtime: '',	
					order_count: 0,
					total_income: 0,
				},			
			}
		},
		mounted() {
			this.initData()
			this.queryOrder()
		},
		components: {
		},
		methods: {
			getBeginDate() { 
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth();
				let day = now.getDate();
				return year + "-" + month + "-" + day;
			},
			getCurrentDate() { 
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				let day = now.getDate();
				return year + "-" + month + "-" + day;
			},
			copyOrderNo(idx,row){
				console.log(idx,row)
				this.selectorderno = row.orderno
				navigator.clipboard.writeText(row.orderno);
				this.$message({ type: 'success', message: '复制成功!' });
			},
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryOrder()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryOrder()
			},
			initData() {
				// queryStallLists({
				// 	state: "normal",
				// 	offset: 0,
				// 	limit: 100
				// }).then(res => {
				// 	console.log(res)
				// 	if (0 == res.code) {
				// 		this.stallList = res.data.data
				// 	}
				// })
			},
			searchData(){
				this.param.page = 1
				this.recordList = []
				this.statinfo.begintime = ''
				this.statinfo.endtime = ''
				this.statinfo.order_count = 0
				this.statinfo.total_income = 0
				this.queryOrder()
			},
			clearSearch(){
				this.searchInfo.sendername = ''
				this.searchInfo.sendertel = ''
				this.searchInfo.begintime = ''
				this.searchInfo.endtime = ''
				this.searchInfo.timevalue = '1'
				this.param.page = 1
				this.queryOrder()
			},
			getOrderStateName(st){
				if(st == 'notpay'){
					return '待支付'
				}else if(st == 'notdining'){
					return '待出餐'
				}else if(st == 'notsend'){
					return '待配送'
				}else if(st == 'sending'){
					return '配送中'
				}else if(st == 'sended'){
					return '待取餐'
				}else if(st == 'pickuped'){
					return '待评论'
				}else if(st == 'overed'){
					return '已结束'
				}else if(st == 'cancel'){
					return '已取消'
				}
				return ''
			},
			queryOrder(){
				this.recordList = []
				queryDeliveryDetailList({
					sendername : this.searchInfo.sendername,
					sendertel: this.searchInfo.sendertel,
					begintime: this.searchInfo.begintime,
					endtime: this.searchInfo.endtime,
					timevalue: this.searchInfo.timevalue,
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.orderTotal = res.data.total
						res.data.data.forEach((item) => {
							this.recordList.push({
								orderno : item.stallsorders_orderno,
								ordertime: dayjs(item.stallsorders_ordertime).format('YYYY-MM-DD'),
								paytime: dayjs(item.service_paytime).format('YYYY-MM-DD'),
								deleverytime : dayjs(item.stallsorders_deleverytime).format('YYYY-MM-DD'),
								orderamount: item.stallsorders_orderamount.toFixed(2),
								orderpayedamount: item.stallsorders_orderpayedamount.toFixed(2),
								deliverpersonname: item.stallsorders_deliverpersonname,
								deliverpersontelphone: item.stallsorders_deliverpersontelphone,
								packprice : item.stallsorders_packprice.toFixed(2),
								deliverfee: item.stallsorders_deliverfee.toFixed(2),
								state: item.stallsorders_state,
								statename : this.getOrderStateName(item.stallsorders_state),
							})
						})
					}
				})

				queryDeliverySaleStat({
					sendername : this.searchInfo.sendername,
					sendertel: this.searchInfo.sendertel,
					begintime: this.searchInfo.begintime,
					endtime: this.searchInfo.endtime,
					timevalue: this.searchInfo.timevalue,
				}).then(res => {
					console.log(res)
					if (0 == res.code) {
						this.statinfo.begintime = res.data.begintime
						this.statinfo.endtime = res.data.endtime
						this.statinfo.order_count = res.data.order_count
						this.statinfo.total_income = res.data.total_income						
					}
				})
			},
			exportOrders(){
				exportDeliveryOrderDetail({
					begintime: this.searchInfo.begintime,
					endtime: this.searchInfo.endtime,
					timevalue: this.searchInfo.timevalue,
				}).then(res => {
					if (0 == res.code) {
						this.downLoad(res.data);
					} else {
						this.$message({ type: 'error', message: res.msg });
					}
				})
			},
			downLoad(filename){			
				var a = document.createElement("a");
				a.href = baseUrl + nfsprefix + "/report/excel/" + filename;
				// a.target = "_blank";
				a.download = filename;
				a.style.display = "none";
				document.body.appendChild(a);
				a.click();
				a.remove();
			},
			goShopUserDetail(idx,row){
				this.detailTitle = '订单详情'
				console.log(idx, row)
				this.selectorderno = row.orderno
				this.detailShow = true
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>